import React, { useContext, useEffect, useRef, useState } from 'react'

import { InfoOutlined } from '@ant-design/icons';
import { Button, Popover, Tour } from 'antd'
import { LOCAL_OPERATION_COUPON_FIRST_OPEN, LOCAL_OPERATION_NOTIFICATION_FIRST_OPEN } from '../../helpers/Globals';

export default function DiMarketingCouponTour({context}) {

   const [open, setOpen] = useState(false);
   
   const backLabel = "Indietro";
   const nextLabel = "Avanti";

   const {
      diAppRef,
   } = context;
  
   const steps = [
      {
         title: 'Benvenuto nella creazione del tuo coupon DylogApp',
         description: 'Queste impostazioni configureranno il coupon che verrà rilasciato al tuo pubblico. Seguile con attenzione!',
         target: () => diAppRef.refOperationsCouponArea.current,
         prevButtonProps: {
            children: backLabel, 
         },
         nextButtonProps: {
            children: nextLabel,
         },
      },
      {
         title: 'Titolo',
         description: 'Inserisci il titolo del coupon che il cliente vedrà in App',
         target: () => diAppRef.refOperationsCouponTitle.current,
         prevButtonProps: {
            children: backLabel, 
         },
         nextButtonProps: {
            children: nextLabel,
         },
      },
      {
         title: 'Il sottotitolo (facoltativo)',
         description: 'Un messaggio breve per arricchire le informazioni del coupon',
         target: () => diAppRef.refOperationsCouponSubtitle.current,
         prevButtonProps: {
            children: backLabel, 
         },
         nextButtonProps: {
            children: nextLabel,
         },
      },
      {
         title: 'Descrizione del coupon (facoltativa ma utile)',
         description: 'Qui puoi inserire la descrizione dei termini promozionali del tuo coupon, molto utile per evitare fraintendimenti!',
         target: () => diAppRef.refOperationsCouponDescription.current,
         prevButtonProps: {
            children: backLabel, 
         },
         nextButtonProps: {
            children: nextLabel,
         },
      },
      {
         title: 'Tipo di sconto del coupon',
         description: 'Scegli se il coupon deve far accedere ad uno sconto in percentuale o a prezzo fisso',
         target: () => diAppRef.refOperationsCouponType.current,
         prevButtonProps: {
            children: backLabel, 
         },
         nextButtonProps: {
            children: nextLabel,
         },
      },
      {
         title: 'Valore del coupon',
         description: 'Qui definisci la cifra a cui questo coupon farà accedere come sconto, in relazione alla tipologia scelta sopra',
         target: () => diAppRef.refOperationsCouponValue.current,
         prevButtonProps: {
            children: backLabel, 
         },
         nextButtonProps: {
            children: nextLabel,
         },
      },
      {
         title: 'Giorni massimi per usarlo',
         description: 'Inserisci entro quanti giorni il cliente può usare questo coupon da quando lo otterrà',
         target: () => diAppRef.refOperationsCouponExpirationDays.current,
         prevButtonProps: {
            children: backLabel, 
         },
         nextButtonProps: {
            children: nextLabel,
         },
      },
      {
         title: 'Utilizzi per cliente',
         description: 'Questo campo indica il cliente quante volte può usufruire del coupon prima della sua cancellazione (minimo 1 volta)',
         target: () => diAppRef.refOperationsCouponCustomerUsage.current,
         prevButtonProps: {
            children: backLabel, 
         },
         nextButtonProps: {
            children: nextLabel,
         },
      },
      {
         title: 'Utilizzi totali',
         description: 'Qui indichi quanti coupon stai dando a tutto il tuo pubblico, ZERO indicherà infiniti coupon. Ma se ad esempio inserisci 10, solamente i primi 10 ottenitori lo riceveranno. (ATTENZIONE IN CASO DI COUPON GRATUITI CHE VERRANNO OTTENUTI IMMEDIATAMENTE)',
         target: () => diAppRef.refOperationsCouponMaxUsage.current,
         prevButtonProps: {
            children: backLabel, 
         },
         nextButtonProps: {
            children: nextLabel,
         },
      },
      {
         title: 'Importo minimo di carrello per usare il coupon',
         description: 'La cifra minima che l\'utente deve mettere a carrello in App o di spesa presso il punto cassa per poter usare questo coupon',
         target: () => diAppRef.refOperationsCouponMinAmountCart.current,
         prevButtonProps: {
            children: backLabel, 
         },
         nextButtonProps: {
            children: nextLabel,
         },
      },
      {
         title: 'Se il coupon è gratuito',
         description: 'Se il coupon è gratuito, arriverà direttamente sulla card del cliente pronto per essere usato, scavalcando la fase dell\'ottenimento. Altrimenti bisognerà indicare i valori di attività per ottenerlo',
         target: () => diAppRef.refOperationsCouponIsFree.current,
         prevButtonProps: {
            children: backLabel, 
         },
         nextButtonProps: {
            children: nextLabel,
         },
      },
      {
         title: 'Giorni per ottenere il coupon',
         description: 'Qui si indicherà il tempo (in giorni) per cui un utente può ottenere il coupon dal suo ricevimento. Passato questo tempo il coupon svanirà ed i clienti che non lo hanno ottenuto non lo vedranno più',
         target: () => diAppRef.refOperationsCouponClaimDays.current,
         prevButtonProps: {
            children: backLabel, 
         },
         nextButtonProps: {
            children: nextLabel,
         },
      },
      {
         title: 'Campagna > Attività > Importo',
         description: 'In questa sezione definisci l\'importo che verrà scaricato sulla card DylogApp del cliente quando vorrà ottenere il coupon',
         target: () => diAppRef.refOperationsCouponCampaignData.current,
         prevButtonProps: {
            children: backLabel, 
         },
         nextButtonProps: {
            children: "Fine",
         },
      },
   ];

   /////////////////////////////////////////////////////////////////////////////////////////// 
   // dopo la prima volta salvo che è stato aperto già in modo da non mostrare il tour //
   ///////////////////////////////////////////////////////////////////////////////////////////

   useEffect(() => {
      
      setTimeout(() => {
         setOpen(localStorage.getItem(LOCAL_OPERATION_COUPON_FIRST_OPEN) ? false : true)
         localStorage.setItem(LOCAL_OPERATION_COUPON_FIRST_OPEN, true)
      }, 1000);

   },[])
   
   /////////////////////////////////////////////////////////////////////////////////////////// 
   // dopo la prima volta salvo che è stato aperto già in modo da non mostrare il tour //
   /////////////////////////////////////////////////////////////////////////////////////////// 
  
   return (
     <>
          <Popover title="Tour del coupon">
            <Button
               onClick={() => setOpen(true)}
               icon={<InfoOutlined />}
               shape='circle'
           />
         </Popover>
         <Tour
            onClose={() => setOpen(false)}
            steps={steps}
            open={open}
         />
     </>
  )
}
